// ??? Am I being used ???
import type { ContestManageStore, SectionQuery, SectionQueryData } from '../types/store';

export const getSectionQueryBySection = (
  cache: ContestManageStore,
  section: SectionQuery
): SectionQueryData | null => {
  switch (section.type) {
    case 'BaseSection': {
      return {
        ...section,
        isLoading: false,
      };
    }
    case 'DynamicSections':
    case 'DynamicSection': {
      const latestSectionQuery = cache.sectionsCache[section.latestQueryKey];

      if (!latestSectionQuery) {
        return {
          key: section.key,
          type: section.type,
          isLoading: false,
        };
      }

      return latestSectionQuery;
    }
    default: {
      // eslint-disable-next-line no-console
      console.log('Unknown section type', section);
      return null;
    }
  }
};

export const getSectionQuery = (
  cache: ContestManageStore,
  sectionKey: string
): SectionQueryData | null => {
  const section = cache.sections[sectionKey];
  if (!section) {
    return null;
  }

  switch (section.type) {
    case 'BaseSection': {
      return {
        ...section,
        isLoading: false,
      };
    }
    case 'DynamicSections':
    case 'DynamicSection': {
      const latestSectionQuery = cache.sectionsCache[section.latestQueryKey];

      if (!latestSectionQuery) {
        return {
          key: section.key,
          type: section.type,
          isLoading: false,
        };
      }

      return latestSectionQuery;
    }
    default: {
      // eslint-disable-next-line no-console
      console.log('Unknown section type', section);
      return null;
    }
  }
};
